import { defineNamespace } from "@nxt-shared/i18n";
import en from "./locales/en.json" with { type: "json" };
export const ui = defineNamespace("ui", en, {
    de: () => import("./locales/de.json"),
});
//# sourceMappingURL=i18n.js.map